export class CzechGrossSalaryIsOverLimitError extends Error {
  constructor(message?: string) {
    super(message ?? "Gross salary is over the limit for social taxes for this type of contract.");
    Object.setPrototypeOf(this, CzechGrossSalaryIsOverLimitError.prototype);
  }
}
